import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  newItems,
  newMenus,
  newBreadCrumb,
  newAuthMenu,
  newDashboard,
} from "../screen/00_Nav/url";
import { isLoggedSelector } from "../store/auth/auth.selector";
import { isOwnerSelector } from "../store/role/role.selector";

export const useMenu = () => {
  // -------------------------- VAR --------------------------
  const { t, i18n } = useTranslation("translation", { keyPrefix: "menu" });
  const language = i18n.language;
  // -------------------------- STATE --------------------------
  const [items, setItems] = useState({});
  const [breadCrumb, setBreadCrumb] = useState([]);
  const [menu, setMenu] = useState([]);
  const [authMenu, setAuthMenu] = useState([]);
  const [dashboard, setDashboard] = useState([]);
  // -------------------------- REDUX --------------------------
  const logged = useSelector(isLoggedSelector);
  const owner = useSelector(isOwnerSelector);
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    const items = newItems(t, "");
    const breadCrumb = newBreadCrumb(items);
    const menu = newMenus(items);
    const authMenu = newAuthMenu(items, logged);
    const dashboard = newDashboard(items);

    //remove setting
    const newMenu = owner ? menu : menu?.filter((item) => item?.key !== "9");

    setItems(items);
    setBreadCrumb(breadCrumb);
    setMenu(newMenu);
    setAuthMenu(authMenu);
    setDashboard(dashboard);
    console.log("menu", menu);
  }, [language, t, logged]);
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return { items, breadCrumb, menu, authMenu, dashboard };
};
